import { Layout, Orientation, Size, Rect } from "@albelli/image-list-view"

export class VerticalSquareLayout implements Layout {
  public readonly orientation: Orientation = Orientation.Vertical

  constructor(private readonly width: number, private readonly betweenSpace?: number, private readonly outsideSpace?: number) {}

  public layout(items: Size[], viewportSize: Size): Rect[] {
    const viewportWidth = viewportSize.width
    // figure out how many columns we gonna have
    const itemsInRow = Math.ceil(viewportWidth / this.width)

    let initCoordValue = 0
    // if we provided outside space value, then it will be our init coordinate
    // we will always consider it's value
    if (this.outsideSpace) {
      initCoordValue = this.outsideSpace
    }

    let x = initCoordValue,
      y = initCoordValue
    const grossWidth = viewportWidth / itemsInRow - initCoordValue
    // it is square, so width and height are same
    const grossHeight = grossWidth

    // if we provided between items space, we always need to consider it
    let betweenSpace = 0
    if (this.betweenSpace) {
      // between space will be reached by reducing width of items and positioning
      // them correctly on coords
      const totalBetweenSpace = this.betweenSpace * (itemsInRow - 1)
      betweenSpace = Math.ceil(totalBetweenSpace / (itemsInRow * 2))
    }
    // in order to get correct width with between space, we need to reduce width twice
    // to consider other sides of column
    const width = Math.floor(grossWidth - betweenSpace * 2)
    const height = width

    // first item always starts at top left, so we can add it to the list
    // from start
    const rects: Rect[] = [{ x, y, width, height }]
    for (let i = 1; i < items.length; i++) {
      // if we don't have any leftover, then it is new row
      if (i % itemsInRow) {
        x = x + grossWidth + betweenSpace
      } else {
        x = initCoordValue
        y = y + grossHeight + betweenSpace
      }

      rects.push({ x, y, width, height })
    }
    return rects
  }
}
